import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function TemplatePreview({ mode, template, onBack, onUseTemplate }) {
  const renderPreviewField = (field) => {
    const commonStyle = {
      width: '100%',
      border: `1px solid ${mode === 'dark' ? '#555' : '#d5d7da'}`,
      borderRadius: 8,
      background: mode === 'dark' ? '#191919' : '#fff',
      color: mode === 'dark' ? '#fff' : '#222',
      padding: '10px 12px',
      fontSize: 14,
      boxSizing: 'border-box',
    };

    if (field.type === 'dropdown') {
      return (
        <select style={commonStyle} disabled>
          <option>{field.placeholder || `Select ${field.label || 'option'}`}</option>
          {(field.options || []).map((option, index) => (
            <option key={`${field.id || field.label}-opt-${index}`}>{option}</option>
          ))}
        </select>
      );
    }

    if (field.type === 'textarea') {
      return (
        <textarea
          rows={3}
          style={{ ...commonStyle, resize: 'vertical' }}
          placeholder={field.placeholder || ''}
          disabled
        />
      );
    }

    const inputType = field.type === 'number' ? 'number' : field.type === 'email' ? 'email' : 'text';
    return <input type={inputType} style={commonStyle} placeholder={field.placeholder || ''} disabled />;
  };

  return (
    <section
      style={{
        padding: '16px 18px',
      }}
    >
      <div style={{ marginBottom: 14, display: 'flex', justifyContent: 'space-between', gap: 10 }}>
        <div>
          <button
            type="button"
            onClick={onBack}
            style={{
              border: `1px solid ${mode === 'dark' ? '#4a4a4a' : '#d0d5dd'}`,
              background: 'transparent',
              color: mode === 'dark' ? '#fff' : '#111',
              borderRadius: 8,
              padding: '7px 12px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              marginBottom: 18,
            }}
          >
            <ArrowBackIcon style={{ fontSize: 18 }} />
            Back to library
          </button>
          <h2
            style={{
              margin: 0,
              fontSize: 20,
              fontWeight: 600,
              color: mode === 'dark' ? '#fff' : '#222',
            }}
          >
            {template?.title || 'Template Preview'}
          </h2>
          <p
            style={{
              marginTop: 6,
              marginBottom: 0,
              color: mode === 'dark' ? '#bdbdbd' : '#667085',
              fontSize: 14,
            }}
          >
            {template?.description || 'Template form preview'}
          </p>
        </div>
        <button
          type="button"
          onClick={() => onUseTemplate(template)}
          style={{
            border: 'none',
            borderRadius: 8,
            background: '#009391',
            color: '#fff',
            fontWeight: 600,
            fontSize: 13,
            padding: '10px 14px',
            cursor: 'pointer',
            height: 40,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <AddIcon style={{ fontSize: 18 }} />
          Use template
        </button>
      </div>

      <div
        style={{
          border: `1px dashed ${mode === 'dark' ? '#4a4a4a' : '#d3d6da'}`,
          borderRadius: 10,
          padding: 14,
        }}
      >
        {(template?.schema_json || []).length === 0 && (
          <div style={{ color: mode === 'dark' ? '#ccc' : '#666', fontSize: 14 }}>
            No fields available in this template.
          </div>
        )}

        {(template?.schema_json || []).map((field, index) => (
          <div key={field.id || `${field.label}-${index}`} style={{ marginBottom: 12 }}>
            <label
              style={{
                display: 'block',
                marginBottom: 6,
                fontSize: 13,
                fontWeight: 500,
                color: mode === 'dark' ? '#e4e4e4' : '#344054',
              }}
            >
              {field.label || `Field ${index + 1}`} {field.required ? '*' : ''}
            </label>
            {renderPreviewField(field)}
          </div>
        ))}
      </div>
    </section>
  );
}

export default TemplatePreview;
